import consumer from "./consumer";

// Single ActionCable subscription
let subscription = null;

// Handlers stored per module key
const moduleHandlers = {};

/**
 * Subscribe to CoreUpdatesChannel with module-specific handlers
 * @param {string} moduleKey - Unique key for the module (e.g., 'appointments')
 * @param {Object} handlers - Object mapping event types to handler functions
 * @returns {Object} unsubscribe function
 */
const subscribeToCoreUpdates = (moduleKey, handlers) => {
  if (!moduleKey) throw new Error("Module key is required");

  // Register handlers for this module
  moduleHandlers[moduleKey] = handlers;

  // Create subscription if it doesn't exist
  if (!subscription) {
    subscription = consumer.subscriptions.create(
      { channel: "CoreUpdatesChannel" },
      {
        connected() {
          console.log("✅ CoreUpdatesChannel connected");
        },
        disconnected() {
          console.log("❌ CoreUpdatesChannel disconnected");
        },
        received(payload) {
          console.log("🔥 RAW PAYLOAD:", payload);
          if (!payload?.type || !payload?.data) return;

          // Call all module handlers that match this payload type
          Object.values(moduleHandlers).forEach((handlerMap) => {
            const handler = handlerMap[payload.type];
              if (handler) {
                try {
                  handler(payload.data);
                } catch (err) {
                  console.error(`Error in handler for ${payload.type}`, err);
                }
              }
          });
        },
      }
    );
  }

  // Return unsubscribe function for this module only
  return () => {
    delete moduleHandlers[moduleKey];

    // If no modules left, unsubscribe completely
    if (Object.keys(moduleHandlers).length === 0 && subscription) {
      subscription.unsubscribe();
      subscription = null;
      console.log("🔌 CoreUpdatesChannel fully unsubscribed");
    }
  };
};

export default subscribeToCoreUpdates;